import React from "react";

import { FormInput } from "./FormInput";
import { FormRadio } from "components/form/formRadio/FormRadio";

import { func_validation } from "functions";



/* Props 
 * {
 *      // Label
 *      isInputOptional: false,
 *      isLabelOptional: false,
 *      inputLabel: "", 
 *      inputSideLabel: "", 
 * 
 *      // Input
 *      inputName: "",
 *      inputValue: "",
 *      inputOptions: [ { radioID, radioValue, radioLabel } ],
 * 
 *      // Input Options
 *      isInputDisabled: false, 
 * 
 *      // Custom Input Validation
 *      customValidator_onChange: (checkboxID, value_formatted)=>{ return value; },
 *      isValuePropagationGuarded_onChange: (value_formatted)=>{ return true/false; },
 * 
 *      // Input Propagation
 *      inputStateName: undefined,
 *      propagateValueChange: (inputStateName, value_formatted)=>{},
 *      handleInputChangeExtend: (checkboxID, value_formatted)=>{},
 * 
 *      // Error Display
 *      isErrorWithinRequired: false,
 *      isErrorOptional: false,
 *      isFormSubmissionAttempted: false,
 * 
 *      // Error Checking
 *      customErrorMsgDefault: "",
 *      customErrorValidation: undefined,
 *      customErrorMsg: "",
 * 
 *      // Custom Error
 *      isInputHasError: false,
 *      customErrorDisplayArray: [{ isError: true|false, errorMsg: "" }],
 * 
 *      // Others
 *      className: "",
 * 		customInputGroupClassName: "",
 *      customInputClassName: "",
 *      formInputCustomTheme: "component-formInputTheme_default",
 *      isMarginBtmOptional: false,
 *      inputCustomOptions: {},
 * }
 */

class FormInput_optionsPresentation extends React.Component {
	constructor(props) {
		super(props);
        this.state = {
        };

        this.handleRadioChange = this.handleRadioChange.bind(this);
    }

    handleRadioChange(value, radioID) {
        const { inputStateName } = this.props;

        // Value
        let value_formatted = value;
        
        // Custom Validator
        if (this.props.customValidator_onChange) value_formatted = this.props.customValidator_onChange(radioID, value_formatted);

        // Update parent state
        if (this.props.propagateValueChange) {
            if (this.props.isValuePropagationGuarded_onChange) {
                if (this.props.isValuePropagationGuarded_onChange(value_formatted)) this.props.propagateValueChange(inputStateName, value_formatted);
            }
            else this.props.propagateValueChange(inputStateName, value_formatted);
        }
        
        // Extension
        if (this.props.handleInputChangeExtend) this.props.handleInputChangeExtend(radioID, value_formatted);
    }

    render() {
        const { className, customInputGroupClassName, customInputClassName, formInputCustomTheme, isMarginBtmOptional, //inputCustomOptions, 
                // Label
                isLabelOptional, inputLabel, inputSideLabel, isInputOptional, 
                // Input
                inputName, inputValue, inputOptions, 
                isInputDisabled,
                // Error Checking
                isErrorWithinRequired, isErrorOptional, 
                isFormSubmissionAttempted, 
                customErrorMsgDefault, customErrorValidation, customErrorMsg,
                isInputHasError, customErrorDisplayArray } = this.props;

        // Label
        let inputLabelDisplay = (
            <span className="component-formInput-label">
                {inputLabel}
                {(isInputOptional)?"":(<span className="component-formInput-labelAsterisk">*</span>)}
            </span>
        );

        // SideLabel
        let inputSideLabelDisplay = (
            <span className="component-formInput-sideLabel">
                {inputSideLabel}
            </span>
        );
        
        // Error Values
        let isError = false;
        let errorMsg = "";
        
        // Error Checking (Default)
        isError = (isFormSubmissionAttempted && !inputValue);
        errorMsg = (func_validation.isStringTrimNotEmpty(customErrorMsgDefault))?customErrorMsgDefault:"Input is Required";
        
        // Custom Error Checking (Empty)
        if (func_validation.isNotNullUndefined(customErrorValidation)) {
            isError = (customErrorValidation);
            errorMsg = (isError && func_validation.isStringTrimNotEmpty(customErrorMsg))?
                        customErrorMsg:errorMsg;
        }
        
        // Error Display
        let errorDisplay = (isError)?(<span className="component-formInput-errorMessage">{errorMsg}</span>):"";
        
        // Custom Error for Input
        let isInputHasError_formatted = func_validation.isBooleanTrueNotNullUndefined(isInputHasError);

        // Custom Error Display
        let customErrorDisplay = "";
        if (func_validation.isArrayNotEmpty(customErrorDisplayArray)) {
            customErrorDisplay = customErrorDisplayArray.map((customErrorDisplayItem, idx)=>{
                let isError_custom = func_validation.getObjectPropertyValue(customErrorDisplayItem, "isError", false);
                let errorMsg_custom = func_validation.getObjectPropertyValue(customErrorDisplayItem, "errorMsg", "");
                if (func_validation.isBooleanTrueNotNullUndefined(isError_custom) && 
                    func_validation.isStringTrimNotEmpty(errorMsg_custom)) {
                    return (<span className="component-formInput-errorMessage" key={idx}>{errorMsg_custom}</span>);
                }
            });
        }
        
        // Input Options
        // let inputCustomOptions_formatted = (func_validation.isObjectNotEmpty(inputCustomOptions)?inputCustomOptions:{});
        
        return (
            <FormInput className={""+((className)?className+" ":"")+
                                       ((formInputCustomTheme)?formInputCustomTheme+" ":"component-formInputTheme_default ")} 
                isMarginBtmOptional={isMarginBtmOptional}>
                
                <div className="component-formInputOptions">

                    {/* Label */}
                    {(isLabelOptional)?"":(
                        (inputSideLabel)?(
                            <div className="component-formInput-labelGroup d-flex align-items-center justify-content-between">
                                {inputLabelDisplay}
                                {inputSideLabelDisplay}
                            </div>
                        ):inputLabelDisplay
                    )}
                    
                    {/* Input */}
					<div className={"component-formInput-inputGroup "+
									((customInputGroupClassName)?customInputGroupClassName+" ":"")}>

                        {(func_validation.isArrayNotEmpty(inputOptions))?(
                            inputOptions.map((inputOption, idx)=>{
                                let radioID = func_validation.getObjectPropertyValue(inputOption, "radioID");
                                let radioValue = func_validation.getObjectPropertyValue(inputOption, "radioValue");
                                let radioLabel = func_validation.getObjectPropertyValue(inputOption, "radioLabel");

                                if (func_validation.isStringTrimNotEmpty(radioID) && 
                                    func_validation.isNotNullUndefined(radioValue)) {
                                    return (
                                        <div key={idx} 
                                            className={"component-formInput-input d-flex align-items-center "+
                                                        ((customInputClassName)?customInputClassName+" ":"")+
                                                        (((isError || isInputHasError_formatted) && !isErrorOptional)?"component-formInput-inputHasError ":"")+
                                                        (((isError || isInputHasError_formatted) && isErrorWithinRequired)?"component-formInputOptions-errorWithin ":"")}>

                                            <FormRadio 
                                                radioGroupName={inputName} 
                                                radioID={radioID} 
                                                radioValue={radioValue} 
                                                radioLabel={radioLabel}

                                                isSelected={inputValue}
                                                isRadioDisabled={isInputDisabled}

                                                handleRadioSelection={this.handleRadioChange} 
                                            />
                                        
                                        </div>
                                    );
                                }
                            })
                        ):""}

                    </div>
                    
                    {/* Error Message */}
                    {(isErrorOptional)?"":(errorDisplay)}
                    
                    {/* Custom Error Message */}
                    {(customErrorDisplay)?customErrorDisplay:""}
                
                </div>
            </FormInput>
        );
    }
}



const FormInput_options = FormInput_optionsPresentation;
export { FormInput_options };